import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';

export const UPDATE_SEARCH_TERMS = 'UPDATE_SEARCH_TERMS';
export const UPDATE_SEARCH_TERMS_ERROR = 'UPDATE_SEARCH_TERMS_ERROR';

export function updateSearchTerms(searchTerms) {
  return { type: UPDATE_SEARCH_TERMS, searchTerms };
}

export function updateSearchTermsError(data) {
  return { type: UPDATE_SEARCH_TERMS_ERROR, error: data.error };
}

export function clear() {
  return (dispatch, store, { network }) => network
    .del(`${config.apiBasePath}/multisearch`)
    .then(() => {
      dispatch(updateSearchTerms([]));
    })
    .catch(err => {
      dispatch(updateSearchTermsError(err.data || UNKNOWN_ERROR));
    });
}

export function loadSearchTerms() {
  return (dispatch, store, { network }) => network
    .get(`${config.apiBasePath}/multisearch`)
    .then(data => {
      dispatch(updateSearchTerms(data));
    })
    .catch(err => {
      dispatch(updateSearchTermsError(err.data || UNKNOWN_ERROR));
    });
}

export function search(terms) {
  return (dispatch, store, { router, network }) => network
    .post(`${config.apiBasePath}/multisearch`, {
      body: JSON.stringify(terms),
    })
    .then(() => {
      dispatch(updateSearchTerms(terms));
      router.push('/webshop/performMultiSearch.do?multiIndex=0&newSearch=true&type=consolidatedMulti');
    })
    .catch(err => {
      dispatch(updateSearchTermsError(err.data || UNKNOWN_ERROR));
    });
}
